function $lang(locale) {
    let def = locale && locale.length > 0 && locale.substring(0,2) != 'es' ? 'en' : 'es'; 
    const language = require(`../localization/${def}.json`);
    return language;
}

module.exports = {
    $lang: $lang
} 